import React from "react";

const Title = ({ children }) => {
  return (
    <h1 className="text-2xl font-bold text-primary-600 dark:text-primary-400">
      {children}
    </h1>
  );
};

export default Title;
